"use client";

import React from "react";
import { Check, X, ArrowRight } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tableData = [{
  feature: "AI-drevet Lead-kvalifisering",
  fin: true,
  op: true,
  cred: true
}, {
  feature: "Automatisert Oppfølging",
  fin: "Begrenset",
  op: "Fullstendig",
  cred: "Fullstendig"
}, {
  feature: "CRM Integrasjon",
  fin: false,
  op: true,
  cred: true
}, {
  feature: "Antall Eiendommer",
  fin: "Opptil 5",
  op: "Ubegrenset",
  prop: "Ubegrenset",
  cred: "Ubegrenset"
}, {
  feature: "Personlig AI-trening",
  fin: "Standard",
  op: "Avansert",
  cred: "Skreddersydd"
}, {
  feature: "Support Respons",
  fin: "24 timer",
  op: "4 timer",
  cred: "Prioritert"
}, {
  feature: "Prioritert Telefon Support",
  fin: "",
  op: true,
  cred: true
}, {
  feature: "VIP Fordeler (Kontakt oss)",
  fin: "",
  op: "",
  cred: ""
}];
export default function LizingaVeidi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const renderCellContent = (value: string | boolean) => {
    if (typeof value === "boolean" || value === "") {
      return value ? <Check className="size-5 text-primary mx-auto" strokeWidth={3} /> : <X className="size-5 text-slate-500 mx-auto opacity-40" strokeWidth={2} />;
    }
    return <span className="text-slate-300 font-sans">{value}</span>;
  };
  return <section data-section-id="224695" id="detaljert-sammenligning" className="w-full py-24 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div ref={ref} className={`max-w-6xl mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tighter">
            Sammenlign Våre Pakker
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Finn den perfekte AI-løsningen for din eiendomsvirksomhet. Fra enkel automatisering til fullstendig digital transformasjon.
          </p>
        </div>

        <div className="rounded-3xl overflow-hidden shadow-4xl border border-white/10 bg-card/40 backdrop-blur-md">
          <Table>
            <TableHeader>
              <TableRow className="border-b border-white/10 bg-secondary/50 hover:bg-secondary/50 relative">
                {}
                <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-70" />
                
                <TableHead className="text-center text-white font-default text-base py-6 pl-6">Standard Pakke</TableHead>
                <TableHead className="text-center text-white font-default text-base py-6">Proff Pakke</TableHead>
                <TableHead className="text-center text-white font-default text-base py-6 pr-6">Ultimat Pakke</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row, i) => <TableRow key={i} data-index={i} className="even:bg-white/5 odd:bg-transparent hover:bg-primary/5 border-b border-white/5 transition-colors">
                  <TableCell className="font-semibold text-white py-5 pl-6 font-default">
                    {row.feature}
                  </TableCell>
                  <TableCell className="text-center py-5">
                    {renderCellContent(row.fin)}
                  </TableCell>
                  <TableCell className="text-center py-5">
                    {renderCellContent(row.op)}
                  </TableCell>
                  <TableCell className="text-center py-5 pr-6">
                    {i === 7 ? <Check className="size-5 text-primary mx-auto" strokeWidth={3} /> : renderCellContent(row.cred)}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto font-default bg-gradient-to-r from-primary to-cyan-500 hover:shadow-lg hover:shadow-primary/20 transition-all rounded-xl">
            <Link to="#">
              Velg Din Plan
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-default border-white/10 text-foreground hover:bg-white/5 backdrop-blur-sm rounded-xl">
            <Link to="//xora.no/bestill/">Bestill</Link>
          </Button>
        </div>
      </div>
    </section>;
}